
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [text]="deviceService.isMobile ? '' : 'Back to search'" defaultHref="events"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div class="page-container">

    <div class="loading-container" *ngIf="!eventSeriesArray">
      <ion-spinner></ion-spinner>
    </div>

    <div *ngIf="eventSeriesArray && eventSeriesArray.length">

      <div class="events-section">

        <div class="events-title">{{ eventSeriesArray[0].name }}</div>
        <div class="events-description">{{ eventSeriesArray[0].description }}</div>

        <div class="event-cards">
          <ion-card class="event-card" *ngFor="let event of eventSeriesArray" (click)="selectEvent(event.id)">
            <ion-card-content class="event-card-content">

              <div class="card-left">
                <p class="card-title">{{ prettyAdjustedDate(event.startTime, event.timezoneOffset) }}</p>
                <p class="card-details">{{ event.longServiceNames }}</p>
                <p class="card-details">{{ adjustedDate(event.startTime, event.timezoneOffset) | timeRangeLong : adjustedDate(event.endTime, event.timezoneOffset) }}</p>
                <p class="card-details">{{ event.numOpenTimeslots }} opening{{ event.numOpenTimeslots == 1 ? '' : 's' }}</p>
              </div>

              <div class="card-right">
                <ion-button fill="outline" class="action-button">View details</ion-button>
              </div>

            </ion-card-content>
          </ion-card>
        </div>
      </div>

      <div class="right-wrapper">
        <img class="right-img" src="assets/img/thrillist.jpg" *ngIf=" firstEventType() == 'Hair' "/>
        <img class="right-img" src="assets/img/massage.jpg" *ngIf=" firstEventType() == 'Massage' "/>
        <img class="right-img" src="assets/img/nails.jpg" *ngIf=" firstEventType() == 'Nails' "/>

        <div class="slack-wrapper">
          <a class="slack-button" [href]="slackUrl"><img alt="Add to Slack" height="40" width="139" src="https://platform.slack-edge.com/img/add_to_slack.png"
              srcset="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" /></a>

          <div class="slack-text">Add our Slack integration to get reminders for Shortcut events at {{ eventSeriesArray[0].name }}.</div>
        </div>
      </div>
      
    </div>

  </div>

</ion-content>
